import { render, staticRenderFns } from "./filter-group.vue?vue&type=template&id=5ec08f3b&"
import script from "./filter-group.vue?vue&type=script&lang=js&"
export * from "./filter-group.vue?vue&type=script&lang=js&"
import style0 from "./filter-group.vue?vue&type=style&index=0&id=5ec08f3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports